import { render, staticRenderFns } from "./TeamPlayer.vue?vue&type=template&id=2b42f366&scoped=true&"
import script from "./TeamPlayer.vue?vue&type=script&lang=js&"
export * from "./TeamPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42f366",
  null
  
)

export default component.exports